import React from "react";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import {
  Container,
  Row,
  Col,
  Breadcrumb,
  Tab,
  Tabs,
  Card,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import bannerImage from "../../Images/student-services/skill-dvelopment-banner.webp";
import modi from "../../Images/commonimg/pm-modi.webp";
import fire from "../../Images/commonimg/fire-sefty.webp";
import img1 from "../../Images/commonimg/ISBMU_Campus_1.webp";
import img2 from "../../Images/commonimg/ISBMU_Campus_2.webp";
import img3 from "../../Images/commonimg/ISBMU_Campus_3.webp";
import img4 from "../../Images/commonimg/ISBMU_Campus_4.webp";
import img5 from "../../Images/commonimg/ISBMU_Campus_5.webp";
import img6 from "../../Images/commonimg/ISBMU_Campus_6.webp";
import img7 from "../../Images/commonimg/ISBMU_Campus_7.webp";
import img8 from "../../Images/commonimg/ISBMU_Campus_8.webp";
import img9 from "../../Images/commonimg/ISBMU_Campus_9.webp";

import sk1 from "../../Images/admision/sk1.webp";
import sk2 from "../../Images/admision/sk2.webp";
import sk3 from "../../Images/admision/sk3.webp";
import sk4 from "../../Images/admision/sk4.webp";
import sk5 from "../../Images/admision/sk5.webp";
import sk6 from "../../Images/admision/sk6.webp";
import sk7 from "../../Images/admision/sk7.webp";
import sk8 from "../../Images/admision/sk8.webp";
import sk9 from "../../Images/admision/sk9.webp";
import sk10 from "../../Images/admision/sk10.webp";
import sk11 from "../../Images/admision/sk11.webp";
import sk12 from "../../Images/admision/sk12.webp";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const SkillDevelopment = () => {
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const skillList = [
    {
      skillName: "Soft Skill Development",
      skillIcon: "brain",
      skillDes:
        "Enhances communication, teamwork, leadership, and interpersonal skills to improve employability, workplace behavior, and professional confidence.",
    },
    {
      skillName: "Computer Hardware Assistant",
      skillIcon: "cpu-2",
      skillDes:
        "Trains students in assembling, maintaining, and troubleshooting computer hardware systems for entry-level IT support and technical roles.",
    },
    {
      skillName: "Computer Network Assistant",
      skillIcon: "devices-2",
      skillDes:
        "Provides knowledge of basic networking concepts, LAN/WAN setup, and maintenance to support efficient and secure organizational communication systems.",
    },
    {
      skillName: "Risk Management & Insurance",
      skillIcon: "brand-asana",
      skillDes:
        "Covers risk assessment, mitigation strategies, and insurance principles to prepare learners for roles in finance and insurance sectors.",
    },
    {
      skillName: "Retail Management",
      skillIcon: "load-balancer",
      skillDes:
        "Introduces retail operations, customer handling, and inventory control to prepare students for dynamic roles in the retail industry.",
    },
    {
      skillName: "Managing Retail",
      skillIcon: "brand-redux",
      skillDes:
        "Focuses on strategic retail planning, merchandising, and sales management to develop leadership capabilities in retail business operations.",
    },
    {
      skillName: "Financial Services",
      skillIcon: "coins",
      skillDes:
        "Equips learners with knowledge of banking, investment, and financial planning essentials for careers in the financial services industry.",
    },
    {
      skillName: "General Bank Management",
      skillIcon: "transaction-rupee",
      skillDes:
        "Teaches core banking operations, customer service, loan processing, and compliance for roles in commercial and cooperative banking sectors.",
    },
  ];

  const skillFeatures = [
    {
      title: "Master Microsoft Excel",
      subtitle:
        "Learn essential formulas, data tools, and spreadsheet functions.",
      image: sk1,
    },
    {
      title: "Speak English with Confidence",
      subtitle:
        "Improve pronunciation, fluency, and day-to-day conversation skills.",
      image: sk2,
    },
    {
      title: "Social Media Marketing Basics",
      subtitle: "Explore platforms, trends, and digital engagement strategies.",
      image: sk3,
    },
    {
      title: "Advanced English Proficiency",
      subtitle:
        "Enhance grammar, vocabulary, and professional communication skills.",
      image: sk4,
    },
    {
      title: "Tally for Accounting Professionals",
      subtitle: "Manage accounts, ledgers, and GST in Tally software.",
      image: sk5,
    },
    {
      title: "Understanding GST in Practice",
      subtitle:
        "Learn GST structure, returns, invoicing, and compliance essentials.",
      image: sk6,
    },
    {
      title: "Effective PowerPoint Presentations",
      subtitle:
        "Design impactful slides for business and academic presentations.",
      image: sk7,
    },
    {
      title: "Microsoft Word Essentials",
      subtitle: "Create, format, and manage documents like a pro.",
      image: sk8,
    },
    {
      title: "Ace Your Job Interviews",
      subtitle: "Develop body language, answers, and confidence to succeed.",
      image: sk9,
    },
    {
      title: "Sales Techniques and Strategy",
      subtitle:
        "Learn persuasion, negotiation, and closing skills for sales success.",
      image: sk10,
    },
    {
      title: "Master iPhone Features & Settings",
      subtitle:
        "Explore shortcuts, security, and productivity features on iOS.",
      image: sk11,
    },
    {
      title: "Android Phone Mastery",
      subtitle: "Discover key Android settings, apps, and hidden tools.",
      image: sk12,
    },
  ];

  return (
    <React.Fragment>
      <title>Skill Development Programs | ISBM University</title>
      <meta
        name="description"
        content="Unlock new opportunities with ISBM University's skill development programs, designed to enhance expertise, boost confidence, and prepare you for career success."
      />
      <Topnav />
      <section
        className="section-hero-banner ptb-50"
        style={{
          backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(77, 77, 77, 0.8)), url(${bannerImage})`,
        }}
      >
        <div className="banner-hero-overlay">
          <div className="container-xxl">
            <div className="section-hero-content">
              <h1>Skill Development</h1>
              <ol className="breadcrumb mt-3 text-center mb-0">
                <li className="breadcrumb-item">
                  <Link
                    to="/"
                    style={{ color: "#fff", textDecoration: "none" }}
                  >
                    Home
                  </Link>
                </li>
                <li
                  className="breadcrumb-item active text-white"
                  aria-current="page"
                >
                  Skill Development
                </li>
                <hr className="section-divider" />
              </ol>
            </div>
          </div>
        </div>
      </section>
      {/* Content Section */}

      {/* Content Section */}
      <section className="skill-content-section ptb-50">
        <div className="container-xxl">
          {/* Mission Statement */}
          <div className="skill-mission-card  m-4">
            <h4 className="skill-mission-statement text-blue modern-title section-title-start">
              We make <span>VOCATIONAL TRAINING </span> inspirational to
              transform INDIA into the <span>SKILL CAPITAL</span> of the world.
            </h4>
            <p>
              In partnership with the Ministry of Skill Development &
              Entrepreneurship (MSDE) and National Skill Development Corporation
              (NSDC), we have launched a state-of-the-art Model Training Centre
              (MTC), called Pradhan Mantri Kaushal Kendra (PMKK) in Gariyabandh,
              Chhattisgarh.
            </p>

            <p>
              We in association with the Ministry and NSDC, are playing a
              pivotal role in creating benchmark institutions that demonstrate
              aspirational value for competency based skill development training
              by focusing on elements of quality, sustainability and connect
              with youth. By addressing the challenges of unemployment and
              ensuring gainful employment for the youth of the state, we are
              enabling and mobilizing Chhattisgarh youth to make them employable
              and work ready.
            </p>

            <p>
              The Pradhan Mantri Kaushal Kendra run by us in Gariyabandh,
              Chhattisgarh will be offering several courses in Agriculture i.e.
              Gardening, Micro-irrigation Technician and Assistant Electrician
              under Civil construction and Plumbing and Sewing Machine Operator.
              These courses have been approved by the Ministry of Skill
              Development & Entrepreneurship (MSDE).
            </p>

            <p>
              We are laying special emphasis on enhancing the personality and
              soft skills of candidates to enhance their employability quotient
              and entrepreneurship skills. Moreover, additional investment has
              been made to impart training on entrepreneurship skills. Besides a
              recreation zone has been set up alongwith a special interview cell
              and an up-to-date library. Additionally to further motivate and
              provide confidence to the candidates, a counselling cum placement
              cell has been made part of the Kaushal Kendra.
            </p>

            <p>
              Skills development is now a national priority and India has a long
              way to go in realizing the benefits of its demographic dividend.
              While the state contributed heavily towards the green revolution
              and made nation self-sufficient in food crops production in
              1960's, there still remain large diaspora of unemployed youth at
              any point of time. This is due to the dearth of industry specific
              skills and domain knowledge in such mainstream education. To
              bridge this employability gap, we are providing livelihood
              training for rural youth to prepare them with hands-on skills
              required for self or wage employment to skill and make them
              job-ready.
            </p>
          </div>

          <Row className="skill-images-row">
            <Col md={6}>
              <div className="skill-image-card">
                <img
                  src={modi}
                  alt="Best university for professional Studies"
                  className="img-fluid skill-image w-100"
                />
              </div>
            </Col>
            <Col md={6}>
              <div className="skill-image-card">
                <img
                  src={fire}
                  alt="Best University for Information and Technology"
                  className="img-fluid skill-image w-100 "
                />
              </div>
            </Col>
          </Row>
        </div>
      </section>

      {/* Courses Offered
          // <div className="skill-courses-section">
          //   <h3 className="skill-section-title ">
          //     <span>ISBM University Offers</span>
          //   </h3>
          //   <ul className="skill-courses-list">
          //     <li>Soft Skill Development</li>
          //     <li>Computer Hardware Assistant</li>
          //     <li>Computer Network Assistant</li>
          //     <li>Risk Management &amp; Insurance</li>
          //     <li>Retail Management</li>
          //     <li>Managing Retail</li>
          //     <li>Financial Services</li>
          //     <li>General Bank Management</li>
          //   </ul>
          // </div> */}

      <section className="pb-50">
        <div className="container-xxl">
          <h2 className="modern-title section-title text-center text-blue mb-4">
            ISBM University Offers
          </h2>
          <Row className="g-4 justify-content-center">
            {skillList.map((skill, index) => (
              <Col md={6} lg={6} key={index}>
                <Card className="border-0 shadow h-100 feature-card">
                  <Card.Body className="p-4 p-lg-5">
                    <div className="row">
                      <div className="feature-icon mb-4 col-lg-2">
                        <i
                          className={`ti ti-${skill.skillIcon} text-blue`}
                          style={{ fontSize: "3rem" }}
                        ></i>
                      </div>
                      <div className="col-lg-10">
                        <Card.Title className="text-blue fs-4 fw-bold mb-3">
                          {skill.skillName}
                        </Card.Title>
                        <Card.Text>{skill.skillDes}</Card.Text>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </div>
      </section>

      {/* Gallery Carousel */}
      <section className="pb-50">
        <div className="container-xxl">
          <div>
            <h3 className="skill-section-title">
              <span>PMKK Gariyabandh Chhattisgarh</span>
            </h3>
            <Slider {...sliderSettings} className="skill-carousel">
              <div className="skill-carousel-item">
                <img src={img1} className="img-fluid" alt="Skill training" />
              </div>
              <div className="skill-carousel-item">
                <img src={img2} className="img-fluid" alt="Skill training" />
              </div>
              <div className="skill-carousel-item">
                <img src={img3} className="img-fluid" alt="Skill training" />
              </div>
              <div className="skill-carousel-item">
                <img src={img4} className="img-fluid" alt="Skill training" />
              </div>
              <div className="skill-carousel-item">
                <img src={img5} className="img-fluid" alt="Skill training" />
              </div>
              <div className="skill-carousel-item">
                <img src={img6} className="img-fluid" alt="Skill training" />
              </div>
              <div className="skill-carousel-item">
                <img src={img7} className="img-fluid" alt="Skill training" />
              </div>
              <div className="skill-carousel-item">
                <img src={img8} className="img-fluid" alt="Skill training" />
              </div>
              <div className="skill-carousel-item">
                <img src={img9} className="img-fluid" alt="Skill training" />
              </div>
            </Slider>
          </div>
        </div>
      </section>

      <section className="pb-50">
        <div className="container-xxl">
          <h2 className="modern-title section-title text-center text-blue mb-5">
            Skills Development
          </h2>
          <Row className="g-4 justify-content-center">
            {skillFeatures.map((feature, index) => (
              <Col md={4} lg={3} key={index}>
                <div class="card text-bg-dark border-0 skill-feature-card">
                  <img
                    src={feature.image}
                    class="card-img h-100"
                    alt={feature.title}
                  />
                  <div
                    class="card-img-overlay d-flex text-center"
                    style={{
                      background:
                        "linear-gradient(180deg, rgba(0,30,98,0.7), rgba(0, 30, 98, 0.7))",
                    }}
                  >
                    <h5 class="card-title fw-bold m-auto">{feature.title}</h5>
                    {/* <div className="underline-divider"></div> */}
                    {/* <p class="card-text">{feature.subtitle}</p> */}
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </div>
      </section>

      {/* PMKK Section */}
      {/* <h3 className="skill-section-title">
              <span>Skills Development:</span>
            </h3> */}
      {/* <ul className="skill-pmkk-list">
              <li>Excel</li>
              <li>English Speaking</li>
              <li>Social Media</li>
              <li>Advance English</li>
              <li>Advance Tally</li>
              <li>GST</li>
              <li>Power Point</li>
              <li>Word</li>
              <li>Interview Skills</li>
              <li>Sales</li>
              <li>Iphone Features</li>
              <li>Android Features</li>
            </ul> */}

      <Footer />
    </React.Fragment>
  );
};

export default SkillDevelopment;
